import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components";
import { CALENDLY_URL } from "@/constants";
import { useTranslation } from "@/i18n";

export const Process: React.FC = () => {
  const t = useTranslation();
  const steps = t.process.steps;

  return (
    <>
      <div id="prozess"></div>
      <div className="bg-[#FAFAFB] py-[72px] md:py-[120px]">
        <div className="max-w-screen-xl m-auto px-[38px] 2xl:px-0">
          <div className="text-center">
            <p className="text-[#01C6FB] font-semibold tracking-[0.18em] uppercase text-[13px] md:text-[14px]">
              {t.process.overline}
            </p>
            <h2 className="mt-3 text-[#171A1F] font-bold text-[28px] leading-[38px] md:text-[44px] md:leading-[56px]">
              {t.process.headline}
            </h2>
            <p className="mt-5 max-w-3xl m-auto text-[16px] leading-[26px] md:text-[18px] md:leading-[30px] text-base-600">
              {t.process.intro}
            </p>
          </div>

          <div className="mt-[48px] md:mt-[64px] max-w-3xl m-auto">
            {steps.map((step, index) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5 }}
                className="relative flex pb-[40px] md:pb-[48px] last:pb-0"
              >
                {/* Timeline line */}
                {index < steps.length - 1 && (
                  <div className="absolute left-[23px] top-[52px] bottom-0 w-[2px] bg-[#01C6FB]/25" />
                )}
                {/* Number bubble */}
                <div className="z-10 flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-full bg-[#01C6FB] text-[18px] font-bold text-[#10141a]">
                  {index + 1}
                </div>
                <div className="ml-6 md:ml-8 pt-[8px]">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="text-[19px] md:text-[22px] font-bold text-[#171A1F]">
                      {step.title}
                    </h3>
                    {"badge" in step && step.badge && (
                      <span className="rounded-full bg-[#01C6FB]/15 border border-[#01C6FB]/40 px-3 py-1 text-[12px] font-semibold text-[#0195bd]">
                        {step.badge}
                      </span>
                    )}
                  </div>
                  <p className="mt-2 text-[15px] leading-[25px] md:text-[16px] md:leading-[28px] text-base-600">
                    {step.text}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mt-[48px] md:mt-[56px] text-center">
            <p className="text-[17px] md:text-[20px] font-medium text-[#171A1F]">
              {t.process.closing}
            </p>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-block mt-6"
            >
              <Button
                shape="circle"
                className="bg-[#01C6FB] text-[#10141a] font-semibold border-0 px-8 hover:bg-[#4dd7fc]"
              >
                {t.process.cta}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
